import React, { forwardRef } from 'react';
import AddBox from '@mui/icons-material/AddBox';
import ArrowDownward from '@mui/icons-material/ArrowDownward';
import Check from '@mui/icons-material/Check';
import ChevronLeft from '@mui/icons-material/ChevronLeft';
import ChevronRight from '@mui/icons-material/ChevronRight';
import Clear from '@mui/icons-material/Clear';
import Close from '@mui/icons-material/Close';
import DeleteOutline from '@mui/icons-material/DeleteOutline';
import Edit from '@mui/icons-material/Edit';
import FilterList from '@mui/icons-material/FilterList';
import FirstPage from '@mui/icons-material/FirstPage';
import LastPage from '@mui/icons-material/LastPage';
import Remove from '@mui/icons-material/Remove';
import SaveAlt from '@mui/icons-material/SaveAlt';
import Search from '@mui/icons-material/Search';
import ViewColumn from '@mui/icons-material/ViewColumn';
import Refresh from "@mui/icons-material/Refresh";
import Error from '@mui/icons-material/Error';
import EmailIcon from '@mui/icons-material/Email';
import CheckBoxOutlineBlank from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxOutlined from "@mui/icons-material/CheckBoxOutlined";
import MoreVertIcon from '@mui/icons-material/MoreVert';
import FileCopyOutlined from "@mui/icons-material/FileCopy";
import ArchiveOutlined from '@mui/icons-material/ArchiveOutlined';
import UnarchiveOutlined from '@mui/icons-material/UnarchiveOutlined';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faQuestionCircle, faThumbsUp, faThumbsDown } from '@fortawesome/free-solid-svg-icons';
import { Share } from '@mui/icons-material';

export const tableIcons = {
  More: forwardRef((props, ref) => <MoreVertIcon {...props} ref={ref} />),
  Question: forwardRef((props, ref) => <FontAwesomeIcon icon={faQuestionCircle} {...props} ref={ref} />),
  ThumbsUp: forwardRef((props, ref) => <FontAwesomeIcon icon={faThumbsUp} {...props} ref={ref} />),
  ThumbsDown: forwardRef((props, ref) => <FontAwesomeIcon icon={faThumbsDown} {...props} ref={ref} />),
  Add: forwardRef((props, ref) => <AddBox {...props} ref={ref} />),
  Check: forwardRef((props, ref) => <Check {...props} ref={ref} />),
  Clear: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
  Delete: forwardRef((props, ref) => (
    <DeleteOutline {...props} ref={ref} />
  )),
  Share: forwardRef((props, ref) => <Share {...props} ref={ref} />),
  DetailPanel: forwardRef((props, ref) => (
    <ChevronRight {...props} ref={ref} />
  )),
  DismissJuror: forwardRef((props, ref) => (
    <Close {...props} ref={ref} />
  )),
  Clone: forwardRef((props, ref) => (
    <FileCopyOutlined {...props} ref={ref} />
  )),
  Archive: forwardRef((props, ref) => (
    <ArchiveOutlined {...props} ref={ref} />
  )),
  Restore: forwardRef((props, ref) => (
    <UnarchiveOutlined {...props} ref={ref} />
  )),
  Edit: forwardRef((props, ref) => <Edit {...props} ref={ref} />),
  Email: forwardRef((props, ref) => <EmailIcon {...props} ref={ref} />),
  Error: forwardRef((props, ref) => <Error {...props} ref={ref} />),
  Export: forwardRef((props, ref) => (
    <SaveAlt {...props} ref={ref} />
  )),
  Filter: forwardRef((props, ref) => (
    <FilterList {...props} ref={ref} />
  )),
  FirstPage: forwardRef((props, ref) => (
    <FirstPage {...props} ref={ref} />
  )),
  LastPage: forwardRef((props, ref) => (
    <LastPage {...props} ref={ref} />
  )),
  MoveToJuryBox: forwardRef((props, ref) => (
    <Check {...props} ref={ref} />
  )),
  NextPage: forwardRef((props, ref) => (
    <ChevronRight {...props} ref={ref} />
  )),
  PreviousPage: forwardRef((props, ref) => (
    <ChevronLeft {...props} ref={ref} />
  )),
  ResetSearch: forwardRef((props, ref) => (
    <Clear {...props} ref={ref} />
  )),
  Search: forwardRef((props, ref) => <Search {...props} ref={ref} />),
  SortArrow: forwardRef((props, ref) => (
    <ArrowDownward {...props} ref={ref} />
  )),
  ThirdStateCheck: forwardRef((props, ref) => (
    <Remove {...props} ref={ref} />
  )),
  ViewColumn: forwardRef((props, ref) => (
    <ViewColumn {...props} ref={ref} />
  )),
  Refresh: forwardRef((props, ref) => (
    <Refresh {...props} ref={ref} />
  )),
  Selected: forwardRef((props, ref) => (
    <CheckBoxOutlined {...props} ref={ref} />
  )),
  NotSelected: forwardRef((props, ref) => (
    <CheckBoxOutlineBlank {...props} ref={ref} />
  ))
};
